<template>
  <div style="overflow-x: auto">
    <table class="table table-bordered table-sm text-center">
      <thead>
        <tr>
          <th rowspan="2">#</th>
          <th rowspan="2">Runner</th>
          <th rowspan="2">Status</th>
          <th rowspan="2" class="text-nowrap">Bet Type</th>
          <th rowspan="2">Odds</th>
          <th colspan="7">HOLD</th>
          <th rowspan="2">BETS</th>
          <th rowspan="2">RESULT</th>
          <th colspan="3">LIABILITY PAYOUT</th>
          <th rowspan="2">COMMENTS</th>
        </tr>
        <tr>
          <th class="text-nowrap">Fixed (Cash)</th>
          <th class="text-nowrap">Tote (Cash)</th>
          <th class="text-nowrap">Total (Cash)</th>
          <th class="text-nowrap">Fixed (Bonus)</th>
          <th class="text-nowrap">Tote (Bonus)</th>
          <th class="text-nowrap">Total (Bonus)</th>
          <th class="text-nowrap">Total (Hold)</th>
          <th class="text-nowrap">Fixed</th>
          <th class="text-nowrap">Tote</th>
          <th class="text-nowrap">Singles</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(item, index) in runners" :key="index">
          <td>
            <div
              class="bg-primary text-white rounded"
              style="width: 20px; height: 20px"
            >
              {{ index + 1 }}
            </div>
          </td>
          <td style="min-width: 200px">
            <div class="d-flex align-items-center text-nowrap">
              <img
                v-if="silkStrip"
                :src="silkStrip"
                style="
                  width: 32px;
                  height: 32px;
                  object-fit: cover;
                  max-width: 100%;
                "
                :style="{
                  objectPosition: item.runnerNo
                    ? `-${32 * (item.runnerNo - 1)}px 0`
                    : '0',
                }"
              />
              <small class="text-wrap text-left">
                {{ item.runnerName }} ({{ item.barrierPosition }})
              </small>
            </div>
          </td>
          <td>
            <b-badge pill variant="dark">betting</b-badge>
          </td>
          <td>
            <small class="d-block mb-0">Win</small>
            <small class="text-muted text-nowrap">Place</small>
          </td>
          <td>
            <small class="d-block mb-0">{{ formatOdd(item.price) }}</small>
            <small class="text-muted text-nowrap">{{
              formatOdd(item.placePrice)
            }}</small>
          </td>
          <td>
            <small class="d-block">{{ item.fixedHold || 0 }}</small>
            <small class="text-muted">0.00</small>
          </td>
          <td>
            <small class="d-block">{{ item.toteHold || 0 }}</small>
            <small class="text-muted">0.00</small>
          </td>
          <td>
            <small class="d-block">{{ item.hold || 0 }}</small>
            <small class="text-muted">0.00</small>
          </td>
          <td>
            <small class="d-block">{{ item.fixedHoldBonus || 0 }}</small>
            <small class="text-muted">0.00</small>
          </td>
          <td>
            <small class="d-block">{{ item.toteHoldBonus || 0 }}</small>
            <small class="text-muted">0.00</small>
          </td>
          <td>
            <small class="d-block">
              {{ (item.fixedHoldBonus || 0) + (item.toteHoldBonus || 0) }}
            </small>
            <small class="text-muted">0</small>
          </td>
          <td>
            <small style="margin-right: 8px">
              {{
                formatCurrencyBuiltInFunc(
                  (item.hold || 0) +
                    (item.fixedHoldBonus || 0) +
                    (item.toteHoldBonus || 0)
                )
              }}
            </small>
            <b-dropdown
              no-caret
              left
              toggle-class="text-muted bg-light p-0"
              variant="link"
              size="sm"
              menu-class="dropdown-fit"
            >
              <template #button-content>
                <feather-icon
                  icon="ChevronDownIcon"
                  style="border-radius: 4px; cursor: pointer"
                />
              </template>

              <div class="d-flex flex-column" style="width: 50px">
                <small>Q: $25</small>
                <small>E: $45</small>
                <small>T: $15</small>
              </div>
            </b-dropdown>
          </td>
          <!-- BETS -->
          <td class="text-nowrap" style="margin-right: 8px">
            {{ item.bets }} bets
            <b-dropdown
              no-caret
              right
              toggle-class="text-muted bg-light p-0"
              variant="link"
              size="sm"
              menu-class="rounded p-0"
              boundary="viewport"
              style="display: inline-block"
              @show="
                () => {
                  selectionId = item.runnerId;
                  handleFetchBetsOnSelection();
                }
              "
            >
              <template #button-content>
                <feather-icon
                  icon="ChevronDownIcon"
                  style="border-radius: 4px; cursor: pointer"
                />
              </template>

              <b-table
                :items="bets"
                :fields="fieldsBets"
                responsive
                thead-class="text-nowrap"
                :busy="loadingSelections"
                show-empty
              >
                <template #cell(username)="{ item }">
                  <span class="text-nowrap">
                    {{ item.username }}
                  </span>
                </template>
                <template #cell(profile)="{ item }">
                  <span> {{ item.profile || "-" }} </span>
                </template>
                <template #cell(stake)="{ item }">
                  <span>
                    {{ formatCurrencyBuiltInFunc(item.odds) || "-" }}
                  </span>
                </template>
                <template #cell(liability)="{ item }">
                  <span>
                    {{ formatCurrencyBuiltInFunc(item.liability) || "-" }}
                  </span>
                </template>
              </b-table>
              <div
                v-if="paginationSelections.total > 0"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                  v-model="pageBet"
                  :total-rows="paginationSelections.total"
                  :per-page="paginationSelections.limit"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                />
              </div>
            </b-dropdown>
          </td>

          <!-- RESULT -->
          <td>- | <span>Live</span></td>

          <!-- PAYOUT -->
          <td>
            <small class="d-block">0.00</small>
            <small class="text-muted">0.00</small>
          </td>
          <td>
            <small class="d-block">0.00</small>
            <small class="text-muted">0.00</small>
          </td>
          <td>
            <small class="d-block">0.00</small>
            <small class="text-muted">0.00</small>
          </td>

          <!-- COMMENTS -->
          <td>
            <b-badge pill variant="danger">{{ item.comment || "-" }}</b-badge>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import {
  BButton,
  BCard,
  BCol,
  BPagination,
  BRow,
  BButtonGroup,
  BTable,
  BCardBody,
  BFormInput,
  BContainer,
  BFormCheckbox,
  BFormCheckboxGroup,
  BBadge,
  BDropdown,
  BDropdownItemButton,
  BDropdownItem,
  BDropdownHeader,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import { formatCurrencyBuiltInFunc } from "@/helpers/utils";
import { mapState, mapActions } from "vuex";
import { format } from "date-fns";
import { stringProp } from "@/helpers/props";
export default {
  components: {
    BDropdown,
    BDropdownItemButton,
    BBadge,
    BContainer,
    BButton,
    BCard,
    BCol,
    BPagination,
    BRow,
    BButtonGroup,
    BTable,
    BCardBody,
    BFormInput,
    flatPickr,
    BFormCheckbox,
    BFormCheckboxGroup,
    FeatherIcon,
    BDropdownItem,
    BDropdownHeader,
  },
  props: {
    silkStrip: stringProp(),
  },
  data() {
    return {
      fields: [
        { key: "race", label: "Race" },
        { key: "time", label: "Time" },
        { key: "status", label: "Status" },
        { key: "runners", label: "Runners" },
        { key: "liability", label: "Liability" },
        { key: "hold", label: "Hold" },
        { key: "netResult", label: "Net Result" },
      ],
      runners: [],
      bets: [],
      fieldsBets: [
        { key: "username", label: "Username" },
        { key: "profile", label: "Profile" },
        { key: "stake", label: "Stake" },
        { key: "liability", label: "Liability" },
      ],
      pageBet: 1,
      selectionId: null,
      users: [],
    };
  },
  computed: {
    ...mapState("trading/racing", [
      "loadingRaces",
      "loadingSelections",
      "paginationSelections",
    ]),
  },
  watch: {
    pageBet() {
      this.handleFetchBetsOnSelection();
    },
    "$route.query.raceId"() {
      this.fetchRunners();
    },
  },
  created() {
    this.fetchRunners();
  },
  methods: {
    ...mapActions("trading/racing", [
      "getRunnersOfRaceWithHold",
      "getBetsOfSelection",
    ]),
    format,
    formatCurrencyBuiltInFunc,
    async fetchRunners() {
      const raceId = this.$route.query.raceId;
      const runners = await this.getRunnersOfRaceWithHold(raceId);
      this.runners = runners;
    },
    async handleFetchBetsOnSelection() {
      if (!this.selectionId) return;
      const result = await this.getBetsOfSelection({
        selectionId: this.selectionId,
        page: this.pageBet,
      });
      this.bets = result;
    },
    formatOdd(odd) {
      if (!odd && odd !== 0) return "-";
      return Number(odd).toFixed(2);
    },
  },
};
</script>
